import styled from 'styled-components';
import { color, font, mixin } from 'shared/utils/styles';
import { InputDebounced, Spinner, Icon } from '../../../../shared';

export const ItemSearch = styled.div`
  padding: 25px 35px 60px;
`;

export const SearchInputCont = styled.div`
  position: relative;
  padding-right: 30px;
  margin-bottom: 40px;
`;

export const SearchInputDebounced = styled(InputDebounced)`
  height: 40px;
  input {
    padding: 0 0 0 32px;
    border: none;
    border-bottom: 2px solid ${color.primary};
    background: #fff;
    ${font.size(1)}
    &:focus,
    &:hover {
      box-shadow: none;
      border: none;
      border-bottom: 2px solid ${color.primary};
      background: #fff;
    }
  }
`;

export const SearchIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  left: 0;
  color: ${color.textMedium};
`;

export const SearchSpinner = styled(Spinner)`
  position: absolute;
  top: 5px;
  right: 30px;
`;

export const BidActivityIcon = styled.i`
  color: ${(props) => props.color ?? 'black'};
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  transition: background 0.1s;
  ${mixin.clickable}
  &:hover {
    background: ${color.backgroundLight};
  }
`;

export const ItemListContainer = styled.div`
  position: absolute;
  width: 275px;
  top: 50px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
`;

export const ItemList = styled.div`
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const ItemData = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

export const ItemTitle = styled.div`
  color: ${color.textDark};
  ${font.size(1)}
`;

export const ItemTypeId = styled.div`
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(1)}
`;

export const SectionTitle = styled.div`
  padding-bottom: 12px;
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.bold}
  ${font.size(1)}
`;

export const NoResults = styled.div`
  padding-top: 50px;
  text-align: center;
`;

export const NoResultsTitle = styled.div`
  padding-top: 30px;
  ${font.medium}
  ${font.size(1)}
`;

export const NoResultsTip = styled.div`
  padding-top: 10px;
  ${font.size(1)}
`;

export const AuctionAndLaneContainer = styled.div`
  & select {
    margin-bottom: 1em;
  }
`;
